import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideWhyNow() {
  return <Slide data-id="element-318">
      <SlideHeader data-id="element-319">Why Now</SlideHeader>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-320">
        <div className="lg:col-span-7" data-id="element-321">
          <motion.h2 variants={itemVariants} className="text-5xl md:text-7xl lg:text-[90px] font-serif leading-[1.05] tracking-tight mb-8" data-id="element-322">
            Atlassian bought DX for $1B.
          </motion.h2>
          <motion.p variants={itemVariants} className="text-2xl md:text-3xl text-gray-400 font-light" data-id="element-323">
            Enterprise wants the independent alternative.
          </motion.p>
        </div>

        <motion.div variants={itemVariants} className="lg:col-span-4 lg:col-start-9 space-y-12" data-id="element-324">
          <div className="border-l border-white pl-6" data-id="element-325">
            <h3 className="text-xl font-medium mb-2" data-id="element-326">AI Tool Explosion</h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-327">
              Teams are adopting Copilot, Cursor, Devin, and Claude Code
              simultaneously. Fragmentation is at an all-time high.
            </p>
          </div>

          <div className="border-l border-white pl-6" data-id="element-328">
            <h3 className="text-xl font-medium mb-2" data-id="element-329">The CFO Mandate</h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-330">
              Finance is demanding ROI justification for massive AI licensing
              costs. Engineering leaders have no data to provide.
            </p>
          </div>

          <div className="border-l border-white pl-6" data-id="element-331">
            <h3 className="text-xl font-medium mb-2" data-id="element-332">No System of Record</h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-333">
              Existing DevEx tools measure human output. None are built to
              measure, orchestrate, or learn from autonomous agents.
            </p>
          </div>

          <div className="border-l border-white pl-6" data-id="element-334">
            <h3 className="text-xl font-medium mb-2" data-id="element-335">
              RL Loops Become Default
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-336">
              Every company will need RL loops in their agents. Without them,
              prompting stays an expert skill — and accuracy plateaus.
            </p>
          </div>
        </motion.div>
      </div>
    </Slide>;
}